import { CLOSE_POPUP, OPEN_POPUP } from '@common/actionTypes';

export const OpenPopup = (key, payload) => ({
  type: OPEN_POPUP,
  key,
  payload,
});

export const ClosePopup = (locationChanged) => ({
  type: CLOSE_POPUP,
  locationChanged,
});
